// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
import Request from './request'

async function fetch (data) {
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  return Request(
    'get',
    localStorage.getItem('pushMidURL') + 'api/sub-account-analyses/index',
    data,
    false,
    headers
  )
}

async function refundExports(data) {// 导出报表
  store.dispatch("fullscreenLoading");
  const response = await Request('get', "api/sub-account-analyses/mfRefundExport", data);
  if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t("Export.recordedHint"));
  }
  store.dispatch("fullscreenLoadingStop");
  return response;
}

async function fetchOrders (data) {
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  return Request(
    'get',
    localStorage.getItem('pushMidURL') + 'api/sub-account-analyses/get-orders',
    data,
    false,
    headers
  )
}

async function fetchReturnOrders (data) {
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  return Request(
    'get',
    localStorage.getItem('pushMidURL') + 'api/sub-account-analyses/get-return-orders',
    data,
    false,
    headers
  )
}

export default {
  fetch,
  refundExports,
  fetchOrders,
  fetchReturnOrders,
}
